// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';
import translationAR from './locales/sa/translation.json';
import translationCN from './locales/cn/translation.json';
import translationES from './locales/es/translation.json';
// Add more languages as needed

const resources = {
  en: {
    translation: translationEN,
  },
  fr: {
    translation: translationFR,
  },
  sa: {
    translation: translationAR,
  },
  cn: {
    translation: translationCN,
  },
  es: {
    translation: translationES,
  },
  // Add more language resources here
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('selectedLanguageCode') || 'en', // Initialize language from local storage
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, 
    },
  });

export default i18n;
